/* eslint-disable react/no-array-index-key */
import React, { memo, useMemo } from 'react'
import PropTypes from 'prop-types';
import { FaTrash } from 'react-icons/fa';
import { Select } from '@components/atoms/select';
import { additionalsData, minMaxOptions } from '@config/data';
import { Button } from '@components/atoms/button';
import { Checkbox } from '@components/atoms/checkbox';
import { TextField } from '@components/atoms/text-field';

export const AdditionalGoals = memo(({ state, onChange, onAdd, onRemove, setState }) => {
  const list = useMemo(() => additionalsData.reduce((acc, item) => [...acc, { id: item, label: item }], []), [])
  return (
    <div className="mb-12 flex flex-col space-y-12">
      <Checkbox
        label="Will you commit to taking progress pictures"
        name="isTakingPhotos"
        value={state.isTakingPhotos}
        onChange={onChange}
        info='Even if you never show anybody, taking progress photos every four weeks can be a great way to motivate yourself. When you diet and workout consistently, your body will change quickly, but not quickly enough that you will notice on a daily basis. You will be under no obligation to share these photos, but if you take a "before" picture on the first day of the fitness challenge, and then tell yourself you will post a before/after on social media at the end of sixteen weeks, that can often be a powerful motivator. Saying yes to this is a promise to yourself to take these pictures (even if you never show anyone) and does not obligate you to post them.'
      />


      {!state.additionalGoals.length ? <div className="text-slate-500">There is no Additional Goals</div> : null}
      {state.additionalGoals.map((item, idx) =>
        <div key={idx} className='flex items-center space-x-5'>
          <div className="bg-red-50 text-red-400 p-2 rounded-full cursor-pointer hover:bg-red-100 hover:text-red-500 transition duration-300" >
            <FaTrash onClick={onRemove(idx)} />
          </div>
          <div className='w-1/3 border-l-2 border-red-100 pl-3'>
            {!item.isCheckedOther &&
              <Select
                label={`Optional Additional Goal #${idx + 1}`}
                name="description"
                id={`description${idx + 1}`}
                value={item.description}
                list={list}
                onChange={e => onChange(e, idx)}
              />
            }
            <div className="flex w-64">
              <Checkbox
                name="isCheckedOther"
                value={item.isCheckedOther}
                onChange={(e) => {
                  onChange(e, idx)
                }}
              />
              <TextField
                placeholder="Other"
                name="description"
                onChange={(e) => {
                  setState(prev => {
                    const data = { ...prev }
                    data.additionalGoals[idx].isCheckedOther = true
                    return data
                  })
                  onChange(e, idx)
                }}
                value={item.description}
              />
            </div>
            {/* <TextArea
              name='description'
              value={item.description}
              onChange={e => onChange(e, idx)}
            /> */}
            <div className="text-slate-600 my-6">How many days a week will you accomplish this goal?</div>
            <div className="flex space-x-4 fle">
              <Select
                className=""
                name="minDays"
                label="Min"
                id={`minDays${idx + 1}`}
                value={item.minDays}
                onChange={e => onChange(e, idx)}
                list={minMaxOptions.slice(1)}
              />
              <Select
                name="maxDays"
                label="Max"
                id={`maxDays${idx + 1}`}
                value={item.maxDays}
                onChange={e => onChange(e, idx)}
                list={minMaxOptions.slice(item.minDays)}
              />
            </div>
          </div>
        </div>
      )}
      {state.additionalGoals.length < 3 ?
        <div className="flex space-x-4">
          <Button variant="secondary" onClick={onAdd}>Add Another Goal</Button>
        </div>
        : null
      }
    </div>
  )
})

AdditionalGoals.propTypes = {
  state: PropTypes.object,
  onChange: PropTypes.func,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  setState: PropTypes.func
}